<template>
	<wt-selector :options="options" v-model="Value" :clearable="true"></wt-selector>
</template>
<script>
export default {
  name: 'order-sampleType-selector',
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      Value: this.value,
      options: []
    }
  },
  watch: {
    value (val) {
      this.Value = val
    },
    Value (val) {
      this.$emit('input', this.Value)
    }
  },
  methods: {
    getOptions () {
      let params = {
        example: { organizationRole: 'LAB' },
        pageableParam: { page: 0, size: 9999, sort: ['createdDate,asc'] }
      }
      let options = []
      this.$store.dispatch('labTestPlatformList', params).then(res => {
        res.data.forEach(ele => {
          let obj = {
            label: ele.name,
            value: ele.name
          }
          options.push(obj)
        })
        this.options = options
      })
    }
  },
  created () {
    this.getOptions()
  }
}
</script>
